var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardWithTitle',{attrs:{"title":_vm.$t('G.LIT_Contact')}},[_c('ContactContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }